<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Contents">
<h1 class="fm_head"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii"><b>Contents</b></span></h1>
<p class="toc_ch" id="rcover"><a href="#/text/9780063079441_Cover#cover"><i>Cover</i></a></p>
<p class="toc_ch" id="rtitle"><a href="#/text/9780063079441_Titlepage#title"><i>Title Page</i></a></p>
<p class="toc_1_ch" id="rded"><a href="#/text/9780063079441_Dedication#ded"><i>Dedication</i></a></p>
<p class="toc_ch" id="rch1"><a href="#/text/9780063079441_Chapter_01#ch1">Chapter 1: Impeachable Offense</a></p>
<p class="toc_ch" id="rch2"><a href="#/text/9780063079441_Chapter_02#ch2">Chapter 2: From Scratch</a></p>
<p class="toc_ch" id="rch3"><span href="#/text/9780063079441_Chapter_03#ch3" title="Link target outside of Sample">Chapter 3: Late Bloomer</span></p>
<p class="toc_ch" id="rch4"><span href="#/text/9780063079441_Chapter_04#ch4" title="Link target outside of Sample">Chapter 4: Right Where I Want to Be</span></p>
<p class="toc_ch" id="rch5"><span href="#/text/9780063079441_Chapter_05#ch5" title="Link target outside of Sample">Chapter 5: The Moral Compass</span></p>
<p class="toc_ch" id="rch6"><span href="#/text/9780063079441_Chapter_06#ch6" title="Link target outside of Sample">Chapter 6: Nothing Starts with Us</span></p>
<p class="toc_ch" id="rch7"><span href="#/text/9780063079441_Chapter_07#ch7" title="Link target outside of Sample">Chapter 7: “I Can’t Believe You Did That”</span></p>
<p class="toc_ch" id="rch8"><span href="#/text/9780063079441_Chapter_08#ch8" title="Link target outside of Sample">Chapter 8: Danger</span></p>
<p class="toc_ch" id="rch9"><span href="#/text/9780063079441_Chapter_09#ch9" title="Link target outside of Sample">Chapter 9: The Absence of the Normal</span></p>
<p class="toc_ch" id="rch10"><span href="#/text/9780063079441_Chapter_10#ch10" title="Link target outside of Sample">Chapter 10: Bigger than Life</span></p>
<p class="toc_ch" id="rch11"><span href="#/text/9780063079441_Chapter_11#ch11" title="Link target outside of Sample">Chapter 11: Testifying</span></p>
<p class="toc_1_ch_0" id="rch12"><span href="#/text/9780063079441_Chapter_12#ch12" title="Link target outside of Sample">Chapter 12: Promotion</span></p>
<p class="toc_1_ch" id="repi"><span href="#/text/9780063079441_Epilogue#epi" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc_ch" id="rack"><span href="#/text/9780063079441_Acknowledgments#ack" title="Link target outside of Sample"><i>Acknowledgments</i></span></p>
<p class="toc_ch" id="rps"><span href="#/text/9780063079441_Section#ps" title="Link target outside of Sample"><i>Photo Section</i></span></p>
<p class="toc_ch" id="rata"><span href="#/text/About_the_Author#ata" title="Link target outside of Sample"><i>About the Author</i></span></p>
<p class="toc_ch" id="rcop"><span href="#/text/9780063079441_Copyright#cop" title="Link target outside of Sample"><i>Copyright</i></span></p>
<p class="toc_ch" id="ratp"><span href="#/text/About_the_Publisher#atp" title="Link target outside of Sample"><i>About the Publisher</i></span><span class="right_1" epub:type="pagebreak" id="page_viii" title="viii"><span class="right_1" epub:type="pagebreak" id="page_ix" title="ix"><span class="right_1" epub:type="pagebreak" id="page_x" title="x"></span></span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780063079441_Contents.vue?4ea9574d